export default __webpack_public_path__ + "images/0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0.png";